import type { PostCampaign } from '../model/types';

export const postOptionsLabel: Record<keyof PostCampaign['options'], string> = {
  hashTag: '해시태그',
  keyword: '키워드',
  link: '링크',
  picture: '장',
  place: '지도',
  text: '자',
  video: '영상',
};
